import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbAccordionModule, NgbNavModule, NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';

// Counter
import { CountUpModule } from 'ngx-countup';

// Apex Chart Package
import { NgApexchartsModule } from 'ng-apexcharts';

import { SharedModule } from '../../shared/shared.module';
import { UtilityRoutingModule } from './utility-routing.modules';
import { StarterComponent } from './starter/starter.component';
import { ProfileComponent } from './profile/profile.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { TimelineComponent } from './timeline/timeline.component';
import { PricingComponent } from './pricing/pricing.component';
import { TeamComponent } from './team/team.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { GalleryComponent } from './gallery/gallery.component';

@NgModule({
  declarations: [
    StarterComponent,
    ProfileComponent,
    InvoiceComponent,
    TimelineComponent,
    PricingComponent,
    TeamComponent,
    PreloaderComponent,
    GalleryComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UtilityRoutingModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbPaginationModule,
    SimplebarAngularModule,
    CountUpModule,
    NgApexchartsModule
  ]
})
export class UtilityModule { }
